import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient, sendhttpClient } from "../httpClient";
import axios from "axios";

export const useGetProductListData = (url_id) => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["allData", url_id],
    queryFn: () => httpClient.get(`/get_scroll?url_id=${url_id}`),
    enabled: !!url_id,
    refetchOnWindowFocus: false,
  });

  return { data, error, isLoading };
};

export const useSendProgress = () => {
  const { mutate, isLoading, data, error } = useMutation({
    mutationFn: async (payload) => {
      const response = await sendhttpClient.post(
        "/player/send_socket_message",
        payload
      );
      return response.data;
    },
  });

  return { mutate, isLoading, data, error };
};

export const useSetProductChangeCall = () => {
  const { mutate, isLoading, data, error } = useMutation({
    mutationFn: async (payload) => {
      const response = await sendhttpClient.post(
        "/player/send_socket_message",
        payload
      );
      return response.data;
    },
  });

  return { mutate, isLoading, data, error };
};

export const useCountryCodes = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["countryCodes"],
    queryFn: async () => {
      const response = await axios.get(
        "https://restcountries.com/v3.1/all?fields=name,idd"
      );

      const formatted = response.data
        .filter(
          (country) =>
            country.idd?.root &&
            country.idd?.suffixes &&
            country.idd.suffixes.length > 0
        )
        .map((country) => ({
          label:
            ` ${country.idd.root}${country.idd.suffixes[0]}`.replace("+", "") +
            " " +
            `(${country.name.common})`,
          value: `${country.idd.root}${country.idd.suffixes[0]}`.replace(
            "+",
            ""
          ),
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      return formatted;
    },
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, error };
};

export const useSubmitData = () => {
  const { mutate, isLoading, data, error } = useMutation({
    mutationFn: async (payload) => {
      const response = await sendhttpClient.post(
        "/contact/add_contact",
        payload
      );
      return {
        status: response.status,
        data: response.data,
      };
    },
  });

  return { mutate, isLoading, data, error };
};
